import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const ScreensGroupHolder = styled.div`
  /* Los dividers verticales del header solo tienen sentido cuando todo
     el header entra en una sola fila (>= 992px) */
  @media (max-width: 991px) {
    .hide-on-mobile {
      display: none !important;
    }
  }
  .screens-group {
    gap: 20px;
  }
  .customPanelStyleDisplays {
    padding-top: 5px;
    padding-bottom: 5px;
    min-width: 0;
  }

  /* Header del grupo (nombre, reglas, acciones, impresiones, inversión, audiencia) */
  .displayGroupHeader.ant-row-flex-top {
    align-items: stretch;
  }
  .displayGroupHeader > .ant-col {
    min-width: 0;
  }
  .groupActions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .col-displays-header-audience {
    margin-top: 15px;
  }

  /* Fila de cada pantalla dentro del grupo */
  .displayRow {
    margin-top: 35px;
  }
  .displayRow > .ant-col {
    min-width: 0;
  }
  .displayInfoCol {
    padding-right: 10px;
  }
  .displayActionsCol {
    padding-right: 5px;
    display: flex;
    justify-content: center;
  }
  .displayActionsInner {
    padding-left: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 320px;
  }
  .colWithBorder {
    border-right: 2px solid ${Colors.borderStrong};
    height: 100%;
  }
  .horizontal-line {
    border-bottom: 1px solid ${Colors.borderStrong};
    marginTop: 10px;
    marginBottom: 15px;
  }
  .col-displays-header {
    text-align: center;
    /* Same height the vertical Dividers give a column, so every column centers
       its content at the same offset whether it renders one or not. */
    min-height: 160px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .col-displays-header-first {
    text-align: center;
    min-height: 110px;
    align-items: center;
  }
  .col-displays {
    text-align: center;
  }
  .content-audience {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    text-align: center;
    margin-bottom: 5px;
  }

  .content-audience-relation {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 5px;
  }
  .contentRelation {
    border: 1px solid ${Colors.border};
    padding: 10px;
    padding-top: 15px;
    border-radius: 16px;
    box-shadow: 0px 0px 4px 1px #0000001A;
    margin: 0 auto;
    min-width: 0;
  }
  @media (max-width: 991px) {
    .contentRelation {
      padding: 10px 6px;
    }
  }
  .tag-status-display {
    margin-left: 5px;
    font-size: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: fit-content;;
  }
  /* Customize css for collapse header*/
  .ant-collapse-item{
    padding: 5px !important;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 5px !important;
  }
  /* >= 992px el header es una sola fila: solo la última columna necesita
     despejar la flecha del collapse. */
  @media (min-width: 992px) {
    .col-displays-header-last {
      padding-right: 40px;
    }
  }
  /* < 992px las columnas se envuelven y cualquiera puede quedar contra la
     flecha: se reserva el espacio en todo el header. */
  @media (max-width: 991px) {
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
      padding: 5px 30px 5px 5px !important;
    }
  }
  .ant-collapse-header {
    color: ${Colors.coal} !important;
  }
  .textGroupColor {
    color: ${Colors.primaryAccent};
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 5px;
  }
  .textGroup {
    font-size: 14px;
    text-align: center;
    margin-bottom: 5px;
  }
  .textGroupRelation {
    text-align: justify;
  }
  .inputGroup {
    width: 95%;
  }
  .content-info-relation {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
  .custom-progress {
    margin-left: 10px;
  }

  .amountCampaignPerDisplay {
    display: grid;
    border: solid;
    padding-top: 4px;
    padding-bottom: 3px;
    color: ${Colors.coal};
    border-radius: 4px;
    border-left-width: 1px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 1px;
    padding-left: 5px;
    padding-right: 5px;
    border-color: #00000026;
    margin-right: 10px;
    margin-left: 3px;
  }

  .dividerDataDisplay {
    width: 2;
    background-color: #0000004d;
    height: 17em
  }

  .content-info {
      height: 25px;
      margin: 10px auto;
      padding: 3px;
      padding-left: 10px !important;
      padding-right: 10px !important;
      border-radius: 4px;
      background-color: ${Colors.extraLightPrimary};
      font-family: Poppins;
      font-size: 12px;
      font-weight: 400;
      line-height: 22px;
      text-align: center;
      color: ${Colors.primaryAccent};
      display: inline;
      &.orange{
        background-color: ${Colors.tintWarning};
        color: ${Colors.atention};
      }
  }
  .buttonActionsGroup {
    margin: 5px 2px 5px 2px;
  }
  .buttonActionsGroup.highlight:hover {
    border-color: ${Colors.atention};
  }
  .buttonActionsDisplayGroup {
    margin-right: 2px;
    margin-left: 2px;
    margin-bottom: 5px;
    font-size: 12px;
  }
  .screenCardAudit {
    padding: 1px 8px 1px 10px;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid ${Colors.primaryAccent};
    background-color: ${Colors.primary};
    margin-bottom: 5px;
    margin-top: 5px;
    color: ${Colors.onPrimary};
    font-size: 15px;
  }
  .screenCardAuditRelation {
    padding: 1px 8px 1px 10px;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid ${Colors.primaryAccent};
    background-color: ${Colors.primary};
    margin-bottom: 5px;
    margin-top: 5px;
    color: ${Colors.onPrimary};
    font-size: 15px;
  }
  .child {
    height: 100%;
  }
  /* Content of list Displays */
  .ant-collapse-content-box {
    padding-left: 0px !important;
    padding-right: 0px !important;
    background: ${Colors.background};
  }
  .slick-next:before {
    color: ${Colors.textMuted};
    font-size: 28px !important;
  }
  .slick-prev:before {
    right: 0px;
    color: ${Colors.textMuted};
    font-size: 28px !important;
  }
  .content-slider-displays {
    margin-left: 6%;
    margin-right: 1%;
  }
  @media (max-width: 991px) {
    .content-slider-displays {
      margin-left: 4%;
      margin-right: 4%;
    }
  }
  .slick-slider {
    min-width: 0;
  }

  /* Slide de cada anuncio (RelationSliderComponent) */
  .relationSlide {
    display: flex;
    flex-wrap: wrap;
  }
  .relationSlide > .ant-col {
    min-width: 0;
  }
  .relationPreviewCol {
    padding-left: 0;
  }
  .relationDataCol {
    padding-left: 20px;
    padding-right: 5px;
    text-align: justify;
  }
  .relationInvestmentCol {
    text-align: justify;
    padding-right: 10px;
  }
  .relationInvestmentInput {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }
  @media (max-width: 991px) {
    .relationInvestmentCol {
      padding-right: 0;
    }
  }
  /* < 768px preview y datos se apilan: el indentado izquierdo ya no separa
     nada y solo le quita ancho a los inputs. */
  @media (max-width: 767px) {
    .relationDataCol {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .grup-info-displays {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .screenContainer {
    width: 200px;
    max-width: 100%;
    margin: 5px 0;
  }
  .screenPreviewType {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .screenPreview {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
  .screenPreviewFilled {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .singleScreen {
    border-bottom: 1px solid ${Colors.primaryAccent};
    padding: 40px 0 5px;
    margin: 0 0 15px;
  }
  .screen {
    background-color: ${Colors.pureBlack};
    border: 4px solid #6f6f70;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inline-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 10px; /* Space between text and input field */
    max-width: 100%;
  }
  .inline-container .ant-input {
    flex: 1 1 auto;
    min-width: 0;
  }
  .inline-text {
    white-space: nowrap; /* Prevent text from wrapping to a new line */
    margin-left: 20px;
  }
  .primaryCircle {
    width: 47px;
    height: 30px;
    background-color: ${Colors.primary};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: ${Colors.onPrimary};
    margin-bottom: 4px;
  }
  .primaryCircleContent {
    width: 35px;
    height: 30px;
    background-color: ${Colors.primary};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: ${Colors.onPrimary};
    margin-bottom: 4px;
  }
  .circleRelation {
    border: 1px solid ${Colors.primaryAccent};
    color: ${Colors.primaryAccent};
    font-size: 13px;
    padding: 2px 8px 2px 8px;
    gap: 13px;
    border-radius: 8px;
    width: fit-content;
    margin-right: 5px;
    margin-bottom: 10px;
    word-wrap: break-word;
    white-space: normal;
  }
  /* Styles for the input */
  .inputGroup {
    flex: 1 1 auto; /* Allow the input to expand to fill available space */
    min-width: 0; /* Prevent the input from causing horizontal overflow */
  }
  .lastRow {
    display: flex;
    flex-direction: row-reverse;
    padding-right: 60px;
    padding-top: 5px;
  }
  .compatibleContent {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    margin-top: 5px;
    color: ${Colors.coal};
    background-color: ${Colors.gray};
    border-radius: 30px;
    padding: 3px 8px;
    font-size: 10px;
    text-align: center;
    justify-content: center;
    white-space: nowrap;
  }
  /* Chips al ancho de su texto: con 80px fijos "Video" o "Px 1920x1080" se
     cortaban (el ellipsis no aplica a texto suelto junto a un icono). */
  .tagsContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
  }
  /* Nombre de la pantalla: el icono a la izquierda y el texto alineado a su
     lado aunque ocupe dos líneas (centrado quedaba desalineado). */
  .displayName {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    text-align: left !important;
  }
  .displayName > .ant-btn {
    flex-shrink: 0;
  }
  .displayName > span {
    padding-top: 1px;
    overflow-wrap: anywhere;
  }
  .totalImpactsContainer{
    flex: 1;
  }
  .screenCardTotalImpacts{
    border-radius: 8px;
    border: 1px solid ${Colors.primaryAccent};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    /* Same height as the impressions InputNumber it sits next to. */
    height: 32px;
    padding: 0 6px;
    background-color: transparent;
    color: ${Colors.primaryAccent};
    font-size: 12px;
  }
  .bonus-input-container:hover .bonus-indicator {
    right: 25px !important;
  }
  .collapseWitthoutHeader {
    .ant-collapse-header {
      display: none;
    }
    .ant-collapse-content {
      background: transparent;
      .ant-collapse-content-box {
        padding: 0px !important;
        .horizontal-line {
          display: none;
        }
      }
    }
  }

  /* (al final para ganar en cascada a las reglas de escritorio de arriba) */
  @media (max-width: 991px) {
    .col-displays-header,
    .col-displays-header-first {
      min-height: 0;
      padding: 8px 4px;
    }
    .col-displays-header-audience {
      margin-top: 0;
    }
    .displayRow {
      margin-top: 24px;
      row-gap: 12px;
    }
    .displayInfoCol {
      padding-right: 0;
    }
    .displayActionsCol {
      padding-right: 0;
    }
    .displayActionsInner {
      padding-left: 0;
      max-width: none;
    }
    /* En tablet/mobile la info de la pantalla (nombre + chips + reglas) va en una fila compacta */
    .tagsContainer {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 6px;
    }
    .compatibleContent {
      width: auto;
      padding: 3px 10px;
      margin: 0;
    }
    /* Info de la pantalla: nombre, chips y reglas en una misma fila */
    .displayInfoCol > div,
    .displayInfoCol > div > div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 6px 14px;
    }
    .displayInfoCol .textGroup {
      margin-bottom: 0 !important;
    }
    .displayInfoCol > div > div > div {
      margin: 0 !important;
    }
    /* Acciones/inversión de la pantalla: bloques en fila, centrados */
    .displayActionsInner {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 8px 20px;
    }
    .displayActionsInner > div {
      margin: 0 !important;
      width: auto !important;
    }
    /* El título "Detalles de pantalla" + divisor ocupa su propia fila completa */
    .displayActionsInner > .displayActionsTitle {
      width: 100% !important;
      flex-basis: 100%;
    }
    .displayActionsInner .content-audience {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 6px 10px;
      margin: 0;
    }
    .displayActionsInner .content-audience > div {
      margin: 0;
    }

    /* ---------- Modo compacto (tablet / mobile) ----------
       Header de grupo y bloque por pantalla en filas densas: etiqueta y valor
       en línea, controles y tipografías más chicas. */

    /* Header del grupo: celdas de ancho automático que se reparten el espacio */
    .displayGroupHeader {
      gap: 6px 10px;
      justify-content: center;
      align-items: center;
      padding: 6px 4px;
    }
    .displayGroupHeader > .ant-col {
      width: auto;
      max-width: 100%;
      flex: 1 1 auto;
      padding: 4px 8px;
      min-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /* Sin los Divider verticales: si no, este display le gana al
       .hide-on-mobile y cada uno estira su columna a 10em. */
    .displayGroupHeader > .ant-col > span,
    .displayGroupHeader > .ant-col > div:not(.ant-divider) {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 4px 8px;
    }
    .displayGroupHeader .textGroup,
    .displayGroupHeader .textGroupColor {
      margin: 0 !important;
      font-size: 13px;
      line-height: 18px;
    }
    .displayGroupHeader .textGroupColor {
      font-size: 14px;
      font-weight: 500;
    }
    .displayGroupHeader .content-info {
      margin: 0;
      height: auto;
      line-height: 18px;
      font-size: 11px;
      padding: 2px 8px !important;
    }
    .displayGroupHeader .groupActions {
      gap: 2px;
    }
    /* Reglas: título e info en línea */
    .displayGroupHeader .titleRuleList {
      margin-bottom: 0;
      font-size: 13px;
      display: inline-flex;
      align-items: center;
    }
    .displayGroupHeader .titleRuleList .buttonActionsGroup {
      margin: 0 0 0 4px !important;
    }
    .displayGroupHeader .nameRules,
    .displayGroupHeader .rulesContainer {
      margin: 0;
      font-size: 12px;
    }
    .displayGroupHeader .nameRules p {
      font-size: 11px;
      line-height: 16px;
    }
    /* Audiencia: chips en fila */
    .displayGroupHeader .content-audience {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 4px 6px;
      margin: 0;
    }
    .displayGroupHeader .content-audience > div {
      margin: 0;
    }

    /* Controles más chicos en toda la sección de grupos */
    .buttonActionsGroup,
    .buttonActionsDisplayGroup {
      width: 28px;
      min-width: 28px;
      height: 28px;
      line-height: 26px;
      font-size: 12px;
      margin: 2px !important;
    }
    .buttonActionsGroup .anticon,
    .buttonActionsDisplayGroup .anticon {
      font-size: 12px;
    }
    .buttonActionsGroup i.fa,
    .buttonActionsDisplayGroup i.fa {
      font-size: 13px !important;
    }
    .ant-input-number {
      height: 30px;
      width: 96px !important;
    }
    /* Impresiones del grupo: master lo llevó a 140px porque ahora muestra
       impresiones (millones) y no salidas; a 96px el número se cortaba. */
    .displayGroupHeader .ant-input-number {
      width: 124px !important;
      max-width: 100%;
    }
    .ant-input-number-input {
      height: 28px;
      font-size: 13px;
    }
    .screenCardAudit,
    .screenCardTotalImpacts,
    .screenCardAuditRelation {
      font-size: 12px;
      padding: 0 8px;
      height: 26px;
      line-height: 24px;
      margin: 2px 0;
    }
    .screenCardAudit .anticon,
    .screenCardTotalImpacts .anticon {
      font-size: 12px;
    }
    .content-info,
    .content-info-relation {
      font-size: 11px;
      line-height: 18px;
      height: auto;
      padding: 2px 8px !important;
    }
    .textGroup {
      font-size: 13px;
      margin-bottom: 2px;
    }
    .compatibleContent {
      font-size: 10px;
      padding: 2px 8px;
    }
    .percentage-input-container {
      width: 70px;
    }
    .percentage-input-container .ant-input-number {
      width: 70px !important;
    }
    /* Inputs de moneda ("$ARS 7.491,06") necesitan más ancho que un número suelto */
    .relationInvestmentInput .ant-input-number {
      width: 140px !important;
    }

    /* Bloque por pantalla (columna derecha de cada display) */
    .displayActionsInner {
      gap: 6px 14px;
    }
    .displayActionsInner .buttonActionsDisplayGroup {
      margin: 2px 1px !important;
    }

    /* Tarjeta de cada anuncio: inputs acotados, etiquetas en línea */
    .relationSlide .textGroupRelation {
      text-align: center;
      width: auto !important;
    }
    .relationInvestmentCol .ant-input-number,
    .relationInvestmentCol .ant-input {
      max-width: 200px;
    }
    .relationInvestmentCol > .ant-col {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 4px 10px;
      margin-top: 4px !important;
    }
    .relationInvestmentCol > .ant-col > .ant-col {
      width: auto;
      flex: 1 1 auto;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 4px 8px;
      margin-top: 0 !important;
    }
    .relationInvestmentInput {
      justify-content: center;
    }
    .inline-container {
      margin-bottom: 8px;
      justify-content: center;
    }
    .inline-container .ant-input {
      max-width: 260px;
      height: 30px;
      font-size: 13px !important;
    }
    .screenContainer {
      width: 160px;
    }
    .totalImpactsContainer {
      margin: 6px 0 0;
    }
    .primaryCircleContent,
    .inactiveCircleContent {
      width: 30px;
      height: 26px;
      font-size: 11px;
    }
  }

  /* Mobile chico: un poco más apretado todavía */
  @media (max-width: 575px) {
    .displayGroupHeader > .ant-col {
      padding: 2px 4px;
    }
    .displayGroupHeader .textGroupColor {
      font-size: 13px;
    }
    .relationInvestmentCol .ant-input-number,
    .relationInvestmentCol .ant-input {
      max-width: 150px;
    }
    .screenContainer {
      width: 140px;
    }
  }
  `;

export default ScreensGroupHolder;